module.exports = __webpack_public_path__ + "static/media/lobby.54aa3e69.jpg";